var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntellijIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f57c00",
    d: "M14.125 35.188L4.438 27.563 9.25 18.625 23.062 24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M44 14.688L43.25 37.813 27.875 44 18.625 38 32.125 24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2962ff",
    d: "M44 14.688L31.812 29.063 26.25 11 31.563 4.625z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ab47bc",
    d: "M34.688 19.625L23.25 37.188 7.25 43 9.813 34 13.125 22.875z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e91e63",
    d: "M13.125 22.875L4 19.813 9.813 4 22.313 5.5 34.688 19.625z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M11 11H36V36H11z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 31.5H23V33H14zM20.5 15.875L20.5 14 15.5 14 15.5 15.875 17 15.875 17 22.375 15.5 22.375 15.5 24.25 20.5 24.25 20.5 22.375 19.159 22.375 19.159 15.875zM25.375 24.5c-1.875 0-2.871-1.098-3.25-1.548l1.411-1.605c.255.282.964 1.028 1.839 1.028 1.125 0 1.375-1.125 1.375-1.75V14H29v6.625c0 .624 0 1.625-.75 2.625C27.725 23.95 26.5 24.5 25.375 24.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellijIdea);
export default __webpack_public_path__ + "static/media/intellij-idea.6a68c1d5fdf82bd43ae5a86de012e031.svg";
export { ForwardRef as ReactComponent };